import { Injectable } from '@angular/core';
import { Adapter } from '../interfaces/adapter';

export class IcdCodes {
  id: number;
  createdOn: Date | null;
  icd10Code: string;
  icd10Name: string;
  searchHelp: string;
  block: string;
  blockName: string;
  chapter: string;
  chapterName: string;

  displayLabel: string;

  public constructor(init?: Partial<IcdCodes>) {
    Object.assign(this, init);
  }
}

@Injectable({
  providedIn: 'root'
})
export class IcdCodesAdapter implements Adapter<IcdCodes> {
  constructor() {}

  adapt(item: any): IcdCodes {
    return new IcdCodes({
      id: item.id,
      createdOn: item.createdOn === '' ? null : new Date(item.createdOn),
      icd10Code: item.icd10Code,
      icd10Name: item.icd10Name,
      searchHelp: item.searchHelp,
      block: item.block,
      blockName: item.blockName,
      chapter: item.chapter,
      chapterName: item.chapterName,
      displayLabel: `${item.icd10Code} - ${item.icd10Name}`
    });
  }
}
